import PencilSVG from '../../assets/svg/pencil.svg';
export default PencilSVG;
